import React from 'react';
import {
  getClosestSunday,
  getPreviousMonday,
} from '../../../../Utils/ProductUtils';
import LighteningDealNew from '../../../Product/ProductDetail/LighteningDealNew';

const LightningComponent = ({ userType, productData }) => {
  const closestSundayTime = getClosestSunday().getTime();
  const date = new Date(closestSundayTime);

  return (
    <div>
      <LighteningDealNew
        endDate={date.toISOString()}
        startDate={getPreviousMonday(closestSundayTime)}
        webDealPrice={productData?.price}
      />

      {/* //     <LighteningDeal
            //         startDate={productData?.dealStartDate}
            //         endDate={productData?.dealEndDate}
            //         dealName={productData?.dealName}
            //     /> */}
    </div>
  );
};

export default LightningComponent;
